const lisbonCalendar = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Europe/Lisbon',
  year: 'numeric',
  month: 'numeric',
});

export function weddingBookingYears(date: Date): string {
  const parts = lisbonCalendar.formatToParts(date);
  const year = Number(parts.find((part) => part.type === 'year')?.value);
  const month = Number(parts.find((part) => part.type === 'month')?.value);

  if (month >= 5 && month <= 10) return `${year} and ${year + 1}`;
  return String(month >= 11 ? year + 1 : year);
}
